// src/utils/eventCategories.ts
//
// The one ordered list of event categories on the client. Order is display
// order everywhere (form picker, Events filter, attendance report columns):
// the three pillars first, then the rest, Admin last. Mirrors
// backend/lib/eventCategories.ts — `Record<EventCategory, …>` below makes the
// compiler flag a category added to the type but not given a label.

import type { EventCategory } from "../types";

const LABELS: Record<EventCategory, string> = {
  BROTHERHOOD: "Brotherhood",
  SERVICE: "Service",
  PROFESSIONAL: "Professional",
  RUSH: "Rush",
  FUNDRAISING: "Fundraising",
  SPECIAL_EVENT: "Special Event",
  ALUMNI_RELATIONS: "Alumni Relations",
  CHAPTER: "Chapter",
  ADMIN: "Admin",
};

export const EVENT_CATEGORIES: readonly EventCategory[] = [
  "BROTHERHOOD",
  "SERVICE",
  "PROFESSIONAL",
  "RUSH",
  "FUNDRAISING",
  "SPECIAL_EVENT",
  "ALUMNI_RELATIONS",
  "CHAPTER",
  "ADMIN",
];

export function eventCategoryLabel(category: EventCategory | string): string {
  return LABELS[category as EventCategory] ?? category;
}
